"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zipCodeFormRules = exports.becomeADealerFormRules = exports.accountsFormRules = exports.identificationFormRules = exports.incomeFormRules = exports.residenceFormRules = exports.personalFormRules = void 0;
const validation_rules_1 = require("./validation-rules");
const { isEmail, isNotEmpty, isOfLength, isOfType, isAlpha, isDate, isOfAgeOrOlder, isShorterOrEq, isOfAgeOrYounger, isAplhaNumeric, isAlphaCaps, isFreeOfForbiddenCharacters, isMatchingOneOf, isGreaterThan, isLessOrEq, isAlphaWithException, isAlphaNumericWithException, isAlphaNumericWithSpace, isMatchingPattern, isTrue, hasIntersection, isNotProfanity, allValuesMustMatch, isNotEmptyList, } = validation_rules_1.rules;
exports.personalFormRules = {
    firstName: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'string'),
            isAlpha,
            (value) => isShorterOrEq(value, 30),
            isNotProfanity,
        ],
        required: true,
    },
    lastName: {
        rules: [
            isNotEmpty,
            isAlpha,
            (value) => isOfType(value, 'string'),
            (value) => isShorterOrEq(value, 30),
            isNotProfanity,
        ],
        required: true,
    },
    dateOfBirth: {
        rules: [
            isNotEmpty,
            isDate,
            (value) => isOfAgeOrOlder(value, 18),
            (value) => isOfAgeOrYounger(value, 125),
        ],
        required: true,
    },
    email: {
        rules: [
            isNotEmpty,
            isEmail,
            (value) => isShorterOrEq(value, 240),
            isNotProfanity,
        ],
        required: true,
    },
    emailConfirmation: {
        rules: [
            isNotEmpty,
            isEmail,
            (value) => isShorterOrEq(value, 240),
            isNotProfanity,
        ],
        required: true,
    },
    phone: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'number'),
            (value) => isOfLength(value, 10, {
                message: 'Please enter a valid phone number',
            }),
            isNotProfanity,
        ],
        required: true,
    },
};
exports.residenceFormRules = {
    addressLine1: {
        rules: [
            isNotEmpty,
            (value) => isAplhaNumeric(value.charAt(0)),
            (value) => isFreeOfForbiddenCharacters(value, /^[^<>*]*$/gm), // <>* chars are not allowed
            (value) => isShorterOrEq(value, 40),
            isNotProfanity,
        ],
        required: true,
    },
    addressLine2: {
        rules: [
            (value) => isFreeOfForbiddenCharacters(value, /^[^<>*]*$/gm),
            isNotProfanity,
        ],
        required: false,
    },
    city: {
        rules: [
            isNotEmpty,
            (value) => isShorterOrEq(value, 64),
            (value) => isAlphaWithException(value, '- '),
            isNotProfanity,
        ],
        required: true,
    },
    monthResiding: {
        rules: [
            isNotEmpty,
            (value) => isDate(value, 'MM/YYYY'),
            (value) => isOfAgeOrYounger(value, 125),
            isNotProfanity,
        ],
        required: true,
    },
    userState: {
        // TODO: @Alex Oleksiiuk: Re-enable this once async validations are enabled and we can pull the state list from the remote.
        // (value: TInput) => isMatchingOneOf(value, ['Choose']),],
        rules: [isNotEmpty, isAlpha, isNotProfanity],
        required: true,
    },
    zipCode: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'number'),
            (value) => isOfLength(value, 5),
            isNotProfanity,
        ],
        required: true,
    },
    ownedBy: {
        rules: [
            isNotEmpty,
            (value) => isMatchingOneOf(value, [
                'Self or Spouse',
                'Relative',
                'Landlord',
                'Military',
            ]),
            isNotProfanity,
        ],
        required: true,
    },
};
exports.incomeFormRules = {
    incomeType: {
        rules: [
            isNotEmpty,
            (value) => isMatchingOneOf(value, [
                'Employee (Gets W-2)',
                'Self-Employed (No W-2)',
                'Fixed Income (Net)',
                'Temp Service Employee',
                'Unemployed',
                'Cash Income',
            ]),
            isNotProfanity,
        ],
        required: true,
    },
    biWeeklyPay: {
        rules: [
            isNotEmpty,
            (value) => isShorterOrEq(value, 9),
            (value) => isOfType(value, 'number'),
            (value) => isGreaterThan(value, 0),
            (value) => isLessOrEq(value, 450000),
            isNotProfanity,
        ],
        required: true,
    },
    employerName: {
        rules: [
            isNotEmpty,
            (value) => isShorterOrEq(value, 30),
            (value) => isAlphaNumericWithSpace(value),
            isNotProfanity,
        ],
        required: false,
    },
    hireDate: {
        rules: [
            isNotEmpty,
            isDate,
            (value) => isOfAgeOrYounger(value, 125),
            (value) => isOfAgeOrOlder(value, 0),
        ],
        required: true,
    },
    employerPhone: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'number'),
            (value) => isOfLength(value, 10, {
                message: 'Please enter a valid phone number',
            }),
            isNotProfanity,
        ],
        required: false,
    },
};
exports.identificationFormRules = {
    ssn: {
        rules: [
            isNotEmpty,
            (value) => isOfLength(value, 11),
            (value) => isMatchingPattern(value, `^(?!000)[0-9]{3}([ -]?)(?!00)[0-9]{2}\\1(?!0000)[0-9]{4}$`),
            isNotProfanity,
        ],
        required: true,
    },
    agreement_consent: { rules: [isTrue], required: true },
};
exports.accountsFormRules = {
    bankingType: {
        rules: [
            isNotEmptyList,
            (value) => allValuesMustMatch(value, [
                'Checking Account',
                'Savings Account',
                'Prepaid Debit Card',
                'No Account',
            ]),
        ],
        required: true,
    },
};
exports.becomeADealerFormRules = {
    isActiveDealer: {
        rules: [(value) => isMatchingOneOf(value, ['Yes'])],
        required: true,
    },
    firstName: {
        rules: [
            isNotEmpty,
            isAlpha,
            (value) => isOfType(value, 'string'),
            (value) => isShorterOrEq(value, 30),
            isNotProfanity,
        ],
        required: true,
    },
    lastName: {
        rules: [
            isNotEmpty,
            isAlpha,
            (value) => isOfType(value, 'string'),
            (value) => isShorterOrEq(value, 30),
            isNotProfanity,
        ],
        required: true,
    },
    dealershipName: {
        rules: [
            isNotEmpty,
            (value) => isAlphaNumericWithException(value, "\\s\\&.,\\-\\+'"),
            (value) => isOfType(value, 'string'),
            (value) => isShorterOrEq(value, 75),
            isNotProfanity,
        ],
        required: true,
    },
    dealershipType: {
        rules: [
            isNotEmptyList,
            (value) => isMatchingOneOf(value, [
                'Buy Here, Pay Here',
                'Independent',
                'Franchise',
            ]),
        ],
        required: true,
    },
    addressLine1: {
        rules: [
            isNotEmptyList,
            (value) => isAplhaNumeric(value.charAt(0)),
            (value) => isFreeOfForbiddenCharacters(value, /^[^<>/\\?;:{}\[\]+=&^%$@!`~'"*]*$/gm),
            (value) => isShorterOrEq(value, 100),
            isNotProfanity,
        ],
        required: true,
    },
    city: {
        rules: [
            isNotEmpty,
            isAlpha,
            (value) => isOfType(value, 'string'),
            (value) => isShorterOrEq(value, 75),
            isNotProfanity,
        ],
        required: true,
    },
    state: {
        rules: [
            isNotEmpty,
            isAlphaCaps,
            isNotProfanity,
            (value) => isOfLength(value, 2),
        ],
        required: true,
    },
    zipCode: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'number'),
            (value) => isOfLength(value, 5),
            isNotProfanity,
        ],
        required: true,
    },
    emailAddress: {
        rules: [
            isNotEmpty,
            isEmail,
            (value) => isShorterOrEq(value, 240),
            isNotProfanity,
        ],
        required: true,
    },
    phoneNumber: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'number'),
            (value) => isOfLength(value, 10, {
                message: 'Please enter a valid phone number',
            }),
            isNotProfanity,
        ],
        required: true,
    },
    emailNotification: { rules: [], required: false },
};
exports.zipCodeFormRules = {
    zipCode: {
        rules: [
            isNotEmpty,
            (value) => isOfType(value, 'number'),
            (value) => isOfLength(value, 5),
            isNotProfanity,
        ],
        required: true,
    },
};
